module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6uIo1"))).then(() => parcelRequire('hEqeo'));